import { useEffect } from "react";
import { ExternalLink } from "lucide-react";
import siteConfig from "../../../config/siteConfig";
import "../HomePage/HeroSection.css";
import "./Hackathon.css";

const PPT_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdcJcu1Gn6mL-s2JICfAUuj0ALSTnbxXQQXxcKR_jLye8G55Q/viewform";

const SubmitPpt = () => {
  const { logo, logoAlt, name } = siteConfig.branding;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="foc-cyber-home hackathon-page">
      <div className="hackathon-wrap">
        <div className="hackathon-header">
          <img className="hackathon-logo" src={logo} alt={logoAlt} />
          <div className="hackathon-kicker">
            <span className="dot" />
            {name} AI Hackathon — PPT Submission
          </div>
          <h1>
            Submit your <span className="accent">PPT</span>
          </h1>
        </div>

        <div className="hackathon-panel">
          <div className="hackathon-nav hackathon-nav-center">
            <a className="btn btn-primary" href={PPT_FORM_URL} target="_blank" rel="noreferrer">
              Open PPT submission form <ExternalLink size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmitPpt;
